import { css } from 'lit';
import componentStyles from '../styles/component.styles.js';
export default css `
    ${componentStyles}

    :host {
        display: block;
    }

    .watching-count {
        display: flex;
        align-items: center;
        gap: var(--sgdf-spacing-x-small);
    }
`;
//# sourceMappingURL=watching-count.styles.js.map